import { render } from "./AcceptInvitation.vue?vue&type=template&id=4b29a6e4"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__